import React, { useState } from 'react';
import {
  withStyles,
  FormControl,
  FormLabel,
  FormGroup,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CleanFilterIcon from '~/assets/clean_filter.svg';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import PF2MButton from '~/components/PF2MButton';
import { newMomentDate } from '~/utils/moment';
import PF2MDatepicker from '~/components/PF2MDatepicker';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';
import Checkbox from '@material-ui/core/Checkbox';
import {
  restoreAnomalyLogsFilter, setCurrentAnomalyLogsFilter,
} from '~/store/dispatch/actions';

const AnomalyLogsFilter = ({ classes }) => {
  const equipmentTypes = useSelector(state => state.nref.equipmentTypes);
  const equipmentGroups = useSelector(state => state.nref.equipmentGroups);
  const equipments = useSelector(state => state.nref.equipments);
  const anomalyTypes = useSelector(state => state.dispatch.anomalyTypes);
  const currentFilter = useSelector(state => state.dispatch.currentAnomalyLogsFilter);
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [errors, setErrors] = useState(false);
  const [message, setMessage] = useState(null);

  const renderSelectAll = () => (
    <div style={{ display: 'flex', alignItems: 'center', paddingTop: '20px' }}>
      <Checkbox
        checked={currentFilter.status}
        color="primary"
        name="all"
        onChange={() => {
          const newFilter = { ...currentFilter, status: !currentFilter.status };
          dispatch(setCurrentAnomalyLogsFilter(newFilter));
        }}
      />
      <FormLabel style={{ padding: 0, margin: 0 }}>
        {translate('common:HideDeletedEvents')}
      </FormLabel>
    </div>
  );

  const validateDate = (value) => {
    const dateTimeMoment = value || null;
    const currentMoment = newMomentDate();

    if (!dateTimeMoment) {
      setMessage(`${translate('validation:FutureTimeCantBeSelected')}`);
      setErrors(true);
      return false;
    }

    if (dateTimeMoment.isAfter(currentMoment)) {
      setMessage(`${translate('validation:FutureTimeCantBeSelected')}`);
      setErrors(true);
      return false;
    }

    setMessage(null);
    setErrors(null);

    return true;
  };

  const renderDatePicker = (filter, key, label) => (
    <FormControl style={{ marginRight: '10px', width: 200 }}>
      <FormLabel className={classes.formLabel}>
        {label}
      </FormLabel>
      <FormGroup>
        <PF2MDatepicker
          format={`${translate('date:DateFormat')} HH:mm:ss`}
          isDateTime
          views={['hours', 'minutes', 'seconds']}
          field={{
            name: key,
            value: filter[key],
          }}
          form={null}
          noParseDate
          maxDate={
            key === 'startDate'
              ? currentFilter.endDate
              : newMomentDate().add(30, 'days')
          }
          minDate={
            key === 'endDate'
              ? currentFilter.startDate
              : newMomentDate().subtract(30, 'days')
          }
          onChange={(e) => {
            const valid = validateDate(e);

            if (!valid) return;

            const newFilter = {
              ...currentFilter,
              [key]: e,
            };

            dispatch(setCurrentAnomalyLogsFilter(newFilter));
          }}
          value={filter[key]}
        />
        { errors && (
          <span style={{ color: 'red', 'font-size': '12px' }}>
            {message}
          </span>
        )
        }
      </FormGroup>
    </FormControl>
  );

  const renderFormControl = (
    item,
    key,
    title,
    collection,
    initialValue = 0,
  ) => (
    <FormControl style={{ marginRight: '10px', width: 200 }}>
      <FormLabel className={classes.formLabel}>
        {title}
      </FormLabel>
      <FormGroup>
        <PF2MSearchSelectOutlined
          placeholder={null}
          className={classnames(classes.field)}
          value={item[key] || initialValue}
          onChange={(e) => {
            const newFilter = {
              ...currentFilter,
              [key]: e.target.value,
            };
            if (key === 'equipType') {
              newFilter.equipGroup = 0;
              newFilter.equip = 0;
            } else if (key === 'equipGroup') {
              newFilter.equip = 0;
            }
            dispatch(setCurrentAnomalyLogsFilter(newFilter));
          }}
        >
          {[{ value: initialValue, label: translate('common:All') }]
            .concat(collection
              .map(e => ({ value: e.id, label: e.name || '0' })))}
        </PF2MSearchSelectOutlined>
      </FormGroup>
    </FormControl>
  );

  return (
    <>
      <div style={{ display: 'flex' }}>
        {renderDatePicker(currentFilter, 'date', translate('common:Date'))}
      </div>
      <div style={{ display: 'flex', marginTop: 10 }}>
        {renderFormControl(currentFilter, 'equipType', translate('common:EquipmentType'), equipmentTypes)}
        {renderFormControl(currentFilter, 'equipGroup', translate('common:EquipmentGroup'), equipmentGroups
          .filter(g => currentFilter.equipType === 0
            || g.id_equipament === currentFilter.equipType))}
        {renderFormControl(currentFilter, 'equip', translate('common:Equipment'), equipments
          .filter(e => (currentFilter.equipType === 0
            || e.id_equip === currentFilter.equipType)
            && (currentFilter.equipGroup === 0
              || e.id_group === currentFilter.equipGroup)))}
        {renderFormControl(currentFilter, 'anomalyType', translate('common:AnomalyType'), anomalyTypes)}
      </div>
      <div style={{ display: 'flex', marginTop: 10 }}>
        <FormControl style={{ width: 200 }}>
          <FormGroup>
            {renderSelectAll()}
          </FormGroup>
        </FormControl>
        <FormControl style={{ width: 200 }}>
          <FormGroup>
            <PF2MButton
              color="primary"
              onClick={() => dispatch(restoreAnomalyLogsFilter())}
              style={{ marginTop: 15 }}
            >
              <img src={CleanFilterIcon} className={classes.icon} alt="" />
              {translate('common:ClearFilters')}
            </PF2MButton>
          </FormGroup>
        </FormControl>
      </div>
    </>
  );
};

AnomalyLogsFilter.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AnomalyLogsFilter);
